import { useState } from "react";
import { Mail, Send, CheckCircle2 } from "lucide-react";

export function BookingRecap({ booking, onSend }) {
  const [open, setOpen] = useState(false);
  const [summary, setSummary] = useState("");
  const [busy, setBusy] = useState(false);
  const past = new Date(booking.scheduled_at) < new Date();
  if (booking.status === "cancelled" || (!past && booking.status !== "completed")) return null;

  const send = async () => {
    setBusy(true);
    try { await onSend(booking.booking_id, summary); setSummary(""); setOpen(false); } finally { setBusy(false); }
  };

  if (booking.recap_sent_at && !open) {
    return (
      <div className="mt-4 flex flex-wrap items-center gap-3 text-xs" data-testid={`recap-done-${booking.booking_id}`}>
        <span className="dg-chip flex items-center gap-1 text-emerald-300"><CheckCircle2 className="w-3 h-3" /> Recap sent {new Date(booking.recap_sent_at).toLocaleDateString()}</span>
        <button type="button" onClick={() => setOpen(true)} className="dg-link" data-testid={`recap-again-${booking.booking_id}`}>Send another recap</button>
      </div>
    );
  }

  return (
    <div className="mt-4 rounded-xl border border-cyan-500/30 bg-cyan-500/5 p-4" data-testid={`recap-box-${booking.booking_id}`}>
      <div className="dg-eyebrow flex items-center gap-1"><Mail className="w-3 h-3" /> Session recap for {booking.name?.split(" ")[0] || "the customer"}</div>
      <p className="text-xs text-slate-400 mt-1">Plain words, one line per item. The customer gets it by email with a "book again" link and your Google review link{booking.payment_status !== "paid" && booking.payment === "after_session" ? <>, <strong className="text-[#FFD600]">plus the secure payment link for ${Number(booking.deposit_usd || 0).toFixed(2)}</strong></> : null}, and the booking is marked completed.</p>
      <textarea className="dg-input mt-2 min-h-[90px] text-sm" value={summary} onChange={(e) => setSummary(e.target.value)} maxLength={4000}
        placeholder={"What we fixed: …\nWhat changed (passwords, settings): …\nIf it happens again: …"} data-testid={`recap-input-${booking.booking_id}`} />
      <div className="mt-2 flex flex-wrap items-center gap-3">
        <button type="button" onClick={send} disabled={busy || summary.trim().length < 10} className="dg-btn-primary rounded-full px-4 py-1.5 text-xs flex items-center gap-1.5 disabled:opacity-40" data-testid={`recap-send-${booking.booking_id}`}>
          <Send className="w-3 h-3" /> {busy ? "Sending…" : booking.payment_status !== "paid" && booking.payment === "after_session" ? "Send recap + payment link & mark completed" : "Send recap & mark completed"}
        </button>
        {booking.recap_sent_at && <button type="button" onClick={() => setOpen(false)} className="dg-link text-xs">Cancel</button>}
        {booking.admin_notes && <button type="button" onClick={() => setSummary(booking.admin_notes)} className="dg-link text-xs" data-testid={`recap-from-notes-${booking.booking_id}`}>Start from my private notes</button>}
      </div>
    </div>
  );
}
